import { getEnvironmentFromHostname, ENVIRONMENTS } from '@/helpers/integrations'

type FlagsmithConfig = {
  environmentID: string
}

const envConfigs: Record<ENVIRONMENTS, FlagsmithConfig> = {
  [ENVIRONMENTS.DEVELOPMENT]: {
    environmentID: 'ZYmMm3b9an6GCrHaG957Sj'
  },
  [ENVIRONMENTS.STAGING]: {
    environmentID: 'VY3F9yv7n9MDg2yhnKCKvC'
  },
  [ENVIRONMENTS.PRODUCTION]: {
    environmentID: 'FwyuuWoqEyW5cjWFXaNdVT'
  }
}

export const getFlagsmithConfig = (): FlagsmithConfig => {
  const environment = getEnvironmentFromHostname()
  return envConfigs[environment]
}

export const flagsmithConfig = getFlagsmithConfig()
